import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@services/translate.service';
import { LocalizationService } from '@app/services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { DataHelper } from '@helpers/data.helper';
import { Router } from '@angular/router';
import { DataService } from '@services/data.service';

export interface DialogData {
  barcode: string;
  type: string;
}
interface ISocialPlatform {
  name: string;
  url: string;
  message?: string; // Opsiyonel, her platform için mesaj gerekmeyebilir
  icon: string;
}
@Component({
  selector: 'qr-dialog',
  templateUrl: '../sharedTemplates/qr.dialog.component.html',
})
export class QRDialog {
  public isReserveButton = true;
  public isReservePageLink = false;

  socialPlatforms: ISocialPlatform[] = [
    {
      name: 'Twitter',
      url: 'https://twitter.com/intent/tweet?url=',
      icon: 'colored-twitter',
    },
    {
      name: 'WhatsApp',
      url: 'https://api.whatsapp.com/send?text=',
      icon: 'colored-whatsapp',
    },
    {
      name: 'Telegram',
      url: 'https://t.me/share/url?url=',
      icon: 'colored-telegram',
    },
    {
      name: 'Copy Link',
      url: '',
      icon: 'colored-copy-link',
    },
  ];
  constructor(
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public dialogRef: MatDialogRef<QRDialog>,
    public _UiHelper: UiHelper,
    public _DataHelper: DataHelper,
    public _DataService: DataService,
    private _Router: Router,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    // console.log("BARCODE-DIALOG::", data);
    this._UiHelper.closeAllMenus();
  }

  betReserveHandler() {
    if (this.isReserveButton) {
      this._DataHelper.setStorageBookBets({
        ...this._DataHelper.qrCodeBookBetBody,
        barCode: Number(this.data.barcode) ? this.data.barcode.toString().substring(3) : '',
      });
      this.isReserveButton = false;
      this._UiHelper.successSnackBar(this._TranslateService.instant('ADD_BOOK_BET_RESERVE'), '');
      this.isReservePageLink = true;
    }
  }

  reverseRouteHandler() {
    this._Router.navigate(['/reserve']);
    this.onNoClick();
    this._UiHelper.p1001SetBottomDialogState('close');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  textReplaceF(text: string): string {
    if (typeof text === 'string') {
      return text.replace(/[,]+/g, '');
    }

    return text;
  }
  copyClickBoard(text) {
    const t_message = this._TranslateService.instant('Copied');
    this._UiHelper.successSnackBar(t_message, '');
    navigator.clipboard.writeText(text).then();
  }
  shareOnSocialMedia(platform) {
    const baseUrl = window.location.origin;
    const homePath = '/home/';
    const message = encodeURIComponent(`${this.data.barcode}`);
    if (platform.url === '') {
      const shareUrl = `${baseUrl}${homePath}${message}`;
      this.copyClickBoard(shareUrl);
    } else {
      const shareUrl = `${platform.url}${baseUrl}${homePath}${message}`;
      window.open(shareUrl, '_blank');
    }
  }
}
